import React from 'react';
import { observer } from 'mobx-react';
import { CardOptions } from '@project/store/shared/RecordCard/types';
import { useRecordCardContext } from './context';

import '@assets/scss/index.scss';
import './style.scss';

interface RecordCardLinkProps {
  tableName: string;
  recordId: string | number;
  options?: Partial<CardOptions>;
}

export const RecordCardLink: React.FC<RecordCardLinkProps> = observer(
  function RecordCardLink({ tableName, recordId, options }) {
    const { recordCardManager } = useRecordCardContext();
    const card = recordCardManager.createCard(tableName, recordId, options);

    const { name } = card.cardInfo;

    // const handleLinkClick = () => {
    //   const { recordId, tableName } = card;
    //   const layer = card.connectedLayer.layerName;
    //   store.linkController.card.setCard({
    //     tableName,
    //     recordId: String(recordId),
    //     layerName: layer,
    //   });
    // };

    // return <a onClick={handleLinkClick}>{name}</a>;
    return <>{name}</>;
  },
);
